// extracted by mini-css-extract-plugin
export var avatar = "_sd-3";
export var avatarContainer = "_sd-2";
export var avatarSpacer = "_sd-5";
export var avatarSpacerContainer = "_sd-4";
export var avatarStackContainer = "_sd-1";
export var bubble = "_sd-0";
export var remainderBubble = "_sd-6";